// extracted by mini-css-extract-plugin
export default {"scroll_down_button":"ScrollDownButton_scroll_down_button__bL0jD"};